export const ACTION_CODE = 'DEAL' + '_LOSS' + '_MOTIVES' + '_ACTION';
